export class DateSerializableValue {
  value?: Date;

  constructor(value?: Date) {
    this.value = value;
  }
}
